import {
    Pipe,
    PipeTransform,
} from "@angular/core";
import { Tournament } from "@Front-end/seed/__generated__";

@Pipe({
    name: "filterGameTournaments",
    standalone: true,
})
export class FilterGameTournamentsPipe implements PipeTransform {

    public transform(tournaments: Tournament[] | null, statuses: string[]): Tournament[] | null {
        return tournaments ? tournaments.filter(tournament => statuses.includes(tournament.status)) : null;
    }
}
